import eventBus from '@/tools/eventBus';

export const i18nMixin = {
    watch: {
        '$i18n.locale'() {
            eventBus.$emit('setPageTitle', this.$i18n.t('pageTitle'));
        }
    },
    created() {
        eventBus.$emit('setPageTitle', this.$i18n.t('pageTitle'));
    }
};
